/** Colour tokens for the default theme, written onto the SVG root as CSS custom properties. */
export const defaultTokens: Record<string, string> = {
  '--bg': '#0b0d12',
  '--bg-glow': '#171a22',
  '--text': '#e8e6e1',
  '--text-dim': '#8b8f9a',
  '--hairline': '#232833',

  '--ring': '#3f4756',
  '--ring-strong': '#79839a',
  '--ring-glow': 'rgba(216, 178, 106, 0.18)',

  '--month-fill': 'rgba(255, 255, 255, 0.016)',
  '--month-fill-alt': 'rgba(255, 255, 255, 0.042)',
  '--month-fill-hover': 'rgba(216, 178, 106, 0.10)',
  '--month-label': '#a6adbb',
  '--month-label-hover': '#f2eee6',
  '--month-rule': '#2c313d',

  '--day': '#7b8494',
  '--day-weekend': '#474f5e',
  '--day-hover': '#f2eee6',

  '--accent': '#d8b26a',
  '--today': '#d8b26a',

  '--mark': '#d8b26a',
  '--mark-note': '#9aa2b1',
  '--leader': '#5b6474',
  '--float-bg': '#161a23',
  '--float-bg-hover': '#1f2531',
  '--float-border': '#2b313d',
  '--avatar-bg': '#252b38',
  '--cluster-bg': '#11151d',
  '--pill-bg': '#2b323f',

  // Float geometry in SCREEN pixels. The scene reads these to size the layout
  // extents (through `floatWorldSize`) and the fragments draw to the same
  // numbers, so packing and painting can never disagree. Unitless on purpose:
  // they are numbers first and CSS custom properties second.
  '--float-w': '158',
  '--float-h': '46',
  '--cluster-w': '156',
  '--cluster-h': '48',
  // Radial gap from the ring to a float's inner edge, in WORLD units. Has to
  // clear the month label band (metrics bandOuter = R + 92).
  '--float-gap': '96',
  // ...but the gap never reads as thinner than this many SCREEN pixels, so
  // floats do not crowd the ring when zoomed out.
  '--float-gap-min-px': '28',
};

/**
 * The tokens a calendar may override from the wire (`Theme.tokens`): every
 * colour above, and none of the geometry. A calendar that could set `--float-w`
 * would be resizing the packer, not repainting the ring, and a token nobody
 * here has heard of has nothing to paint.
 */
export const COLOUR_TOKENS: readonly string[] = Object.keys(defaultTokens).filter(
  (name) => !/^--(float|cluster)-/.test(name),
);
